export enum NetworkEnum {
  BTC = 3,
  TRX = 4,
  ETH = 5,
  NEO = 10,
  BNB = 13,
  BSC = 95,
  ERC20 = 78,
}
